<template>
  <v-container fluid class="login-page pa-0 d-flex align-center justify-center">
    <div class="auth-frame">
      <v-row no-gutters class="fill-height">
        <!-- LEFT: Login form -->
        <v-col cols="12" md="6" class="d-flex align-center justify-center form-panel pa-8 pa-md-12">
          <div class="form-inner">
            <v-img
              class="mb-8"
              height="40"
              max-width="130"
              src="./logo.png"
            ></v-img>

            <div class="mb-8">
              <div class="welcome-text">Welcome back</div>
              <div class="sub-text">Login to your dashboard</div>
            </div>

            <v-form ref="loginForm" v-model="isValid">
              <span class="field-label">Email</span>
              <v-text-field
                class="mt-2 pill-field"
                ref="email"
                :rules="rules.required"
                v-model="formData.email"
                density="comfortable"
                placeholder="you@example.com"
                variant="solo"
                flat
                rounded="pill"
                bg-color="#f5f5f8"
                @keydown.enter="Login()"
              />

              <span class="field-label">Password</span>
              <v-text-field
                class="mt-2 pill-field"
                ref="password"
                :rules="rules.password"
                v-model="formData.password"
                density="comfortable"
                placeholder="Enter your password"
                :append-inner-icon="visible ? 'mdi-eye-off' : 'mdi-eye'"
                :type="visible ? 'text' : 'password'"
                @click:append-inner="visible = !visible"
                variant="solo"
                flat
                rounded="pill"
                bg-color="#f5f5f8"
                @keydown.enter="Login()"
              />
            </v-form>

            <v-btn
              @click="Login()"
              block
              size="large"
              rounded="pill"
              class="text-none text-subtitle-1 login-btn mt-4"
              elevation="0"
              variant="flat"
            >
              <span class="login--text" v-if="!loginState">Login</span>
              <v-progress-circular
                :width="3"
                color="#2d2a4a"
                indeterminate
                v-if="loginState"
              ></v-progress-circular>
            </v-btn>

            <div class="text-center mt-4">
              <v-btn
                :to="{ name: 'forgot' }"
                text
                class="text-none text-subtitle-2 forgot-btn"
                variant="text"
              >
                <v-icon size="16" class="mr-1">mdi-lock-outline</v-icon>
                <span class="forgot--text">Forgot Password?</span>
              </v-btn>
            </div>
          </div>
        </v-col>

        <!-- RIGHT: Photo panel with floating cards -->
        <v-col cols="12" md="6" class="d-none d-md-flex photo-panel">
          <!--
            Swap the gradient below for a real photo:
            background: url('./team-photo.jpg') center/cover no-repeat;
          -->
          <div class="photo-bg"></div>
          <div class="photo-scrim"></div>

          <v-btn icon size="small" class="close-btn" variant="flat" elevation="1">
            <v-icon size="18">mdi-close</v-icon>
          </v-btn>

          <!-- Floating notification card -->
          <div class="float-card notification-card">
            <div class="notif-dot"></div>
            <div>
              <div class="notif-title">Campaign Sent</div>
              <div class="notif-sub">128 recipients &middot; just now</div>
            </div>
          </div>

          <!-- Floating avatars / meeting card -->
          <div class="float-card meeting-card">
            <div class="meeting-title">
              <span>Today's Overview</span>
              <span class="meeting-dot"></span>
            </div>
            <div class="meeting-time">09:30am &ndash; 10:00am</div>
            <div class="avatar-row">
              <div class="avatar-chip">A</div>
              <div class="avatar-chip">B</div>
              <div class="avatar-chip">C</div>
              <div class="avatar-more">+4</div>
            </div>
          </div>

          <div class="photo-caption">
            <div class="caption-title">Manage your dashboard,<br />anywhere.</div>
            <div class="caption-sub">
              Secure access to your account, campaigns, and tools — all in one place.
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import eventBus from "../../../utils/eventBus";
export default {
  name: "testPage",

  data() {
    return {
      isValid: false,
      loginState: false,
      screenSize: "",
      visible: false,
      formData: {
        email: "",
        password: "",
      },
      showPassword: false,
      rules: {
        required: [(value) => !!value || "Required."],
        email: [
          (value) => !!value || "Required.",
          (value) => /.+@.+\..+/.test(value) || "Invalid email address.",
        ],
        password: [(value) => !!value || "Required."],
      },
    };
  },

  computed: {},

  mounted() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);

    eventBus.on("showOtpPage", () => {
      this.$router.push({ name: "loginOtp" });
    });
  },
  methods: {
    Login() {
      if (!this.isValid) {
        this.$refs.loginForm.validate();
      } else {
        this.loginState = true;
        this.$store.dispatch("auth/loginwithOtp", this.formData);
      }
    },
    checkScreenSize() {
      const isSmallScreen = window.matchMedia("(max-width: 768px)").matches;
      this.screenSize = isSmallScreen ? "Small" : "Large";
    },
    redirect() {
      this.$router.push({ name: "test" });
    },
  },

  watch: {
    loginState(newVal) {
      if (newVal === true) {
        setTimeout(() => {
          this.loginState = false;
        }, 2000);
      }
    },
  },
};
</script>

<style>
/* @import url("../authStyle.css"); */
</style>

<style scoped>
.login-page {
  min-height: 100vh;
  background: #eceef2;
  padding: 32px !important;
  /* background-image: url('https://images.unsplash.com/photo-1643845892686-30c241c3938c?q=80&w=688&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D') ; */
}

.auth-frame {
  width: 100%;
  max-width: 1100px;
  height: 640px;
  max-height: 92vh;
  border-radius: 32px;
  overflow: hidden;
  box-shadow: 0 30px 60px -20px rgba(45, 42, 74, 0.25);
  background: #fff;
}

.fill-height {
  height: 100%;
}

/* ---------- LEFT: FORM ---------- */
.form-panel {
  height: 100%;
  background: #fff;
}

.form-inner {
  width: 100%;
  max-width: 340px;
}

.welcome-text {
  font-size: 26px;
  font-weight: 700;
  color: #2d2a4a;
}

.sub-text {
  font-size: 14px;
  color: #8a8a9a;
  margin-top: 4px;
}

.field-label {
  font-size: 13px;
  font-weight: 600;
  color: #4a4a5a;
}

.pill-field :deep(.v-field) {
  box-shadow: none;
}

.login-btn {
  height: 48px !important;
  font-weight: 700;
  letter-spacing: 0.3px;
  background: #f4c542 !important;
  color: #2d2a4a !important;
}

.login-btn:hover {
  background: #f0b92b !important;
}

.forgot-btn {
  opacity: 0.8;
  color: #6b6b80 !important;
}

.forgot-btn:hover {
  opacity: 1;
}

/* ---------- RIGHT: PHOTO PANEL ---------- */
.photo-panel {
  position: relative;
  height: 100%;
  overflow: hidden;
  padding: 20px;
  
}

.photo-bg {
  position: absolute;
  inset: 20px;
  border-radius: 24px;
  background: url('https://plus.unsplash.com/premium_photo-1682309526815-efe5d6225117?q=80&w=1212&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D') center/cover no-repeat;
  /* background: linear-gradient(150deg, #3f4478 0%, #50568e 55%, #6b70b3 100%); */
  /* Swap gradient for a real photo:
     background: url('./team-photo.jpg') center/cover no-repeat;
  */
}

.photo-scrim {
  position: absolute;
  inset: 20px;
  border-radius: 24px;
  background: linear-gradient(to top, rgba(30, 28, 55, 0.55) 0%, rgba(30, 28, 55, 0) 45%);
}

.close-btn {
  position: absolute;
  top: 36px;
  right: 36px;
  z-index: 3;
  background: rgba(255, 255, 255, 0.9) !important;
}

.float-card {
  position: absolute;
  z-index: 3;
  background: #fff;
  border-radius: 16px;
  padding: 12px 16px;
  box-shadow: 0 12px 28px -8px rgba(20, 20, 40, 0.25);
}

.notification-card {
  top: 48px;
  left: 40px;
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 210px;
}

.notif-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #4caf50;
  flex-shrink: 0;
}

.notif-title {
  font-size: 13px;
  font-weight: 700;
  color: #2d2a4a;
}

.notif-sub {
  font-size: 11px;
  color: #9a9aa8;
  margin-top: 2px;
}

.meeting-card {
  bottom: 130px;
  right: 40px;
  min-width: 190px;
}

.meeting-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  font-weight: 700;
  color: #2d2a4a;
}

.meeting-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #f4c542;
}

.meeting-time {
  font-size: 11px;
  color: #9a9aa8;
  margin: 4px 0 10px;
}

.avatar-row {
  display: flex;
  align-items: center;
}

.avatar-chip {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #50568e;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #fff;
  margin-left: -8px;
}

.avatar-chip:first-child {
  margin-left: 0;
}

.avatar-more {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #eceef2;
  color: #6b6b80;
  font-size: 10px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #fff;
  margin-left: -8px;
}

.photo-caption {
  position: absolute;
  bottom: 44px;
  left: 40px;
  right: 40px;
  z-index: 3;
  color: #fff;
}

.caption-title {
  font-size: 24px;
  font-weight: 700;
  line-height: 1.3;
  margin-bottom: 8px;
}

.caption-sub {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
  max-width: 320px;
}
</style>